<template>
    <div class="custom-select" :class="{selectdrop: name !== 'birthDay' || name !== 'area', selectdrop2: name === 'birthDay' || name === 'area', 
                'countries-select': name === 'area' , citySelect:name==='city' , countrySelect:name==='country' , areaSelect:name==='area'}">
        <select v-if="name !== 'area' && name !== 'city' && name!=='country'" class="rigister_slect" v-model="model" :data-model="name">
            <option :value="odr.value" v-for="(odr, idx) of options" :key="idx">{{odr.name}}</option>
        </select>
        <select v-if="name ==='country'" class="rigister_slect" id="register_country" v-model="model" :data-model="name">
            <option :value="odr.value" v-for="(odr, idx) of options" :key="idx">{{odr.name}}</option>
        </select>
        <select v-if="name === 'city'" class="rigister_slect" v-model="model" :data-model="name">
            <option value="1">縣市</option>
            <option :value="cty.City" v-for="(cty, idx) of options" :key="idx">{{cty.City}}</option>
        </select>
        <select v-if="name === 'area'" class="rigister_slect" v-model="model" :data-model="name">
            <option value="1">地區</option>
            <option :value="country.District" v-for="(country, idx) of options" :key="idx">{{country.District}}</option>
        </select>
    </div>
</template>

<script>
import axios from 'axios'
import {API_URL, userStatus, newsOrder, sourceTree} from './config.js'
import user from './user.js'
import select from './libs/jquery.select.js'

export default {
  name: 'CustDropdown',
  props: ["name", "options", "model"],
  data () {
    return {
      selected: this.name
    }
  },
  methods: {
    ...user,
  },
  computed: {
    bookType: function () {
        let keys = Object.keys(this.$root.bookType)
        this.$root.removeItemFromArray(keys,'index')
        this.$root.removeItemFromArray(keys,'novel')
        return keys
    },
    pageKey: function () {
        let keys = Object.keys(this.$root.bookType)
        let locate
        keys.map(key => {
            if (this.$root.bookType[key].id == this.id) locate = key
        })
        return locate
    }
  },
  mounted () {
    // console.log(`${this.name} mounted`)
    // console.log(`${this.$el}`)
    let dropdown = this.$el
    if (this.options && this.options.length) {
        select.bindOneDropdown.bind(this)(dropdown, this.name === 'area')
    }
    if (this.name === 'area') {
        // console.log(dropdown)
        // console.log('area bind ')
        select.bindOneDropdown.bind(this)(dropdown, this.name === 'area')
    }

    if (this.name === 'city' || this.name === 'area') {
        // this.$watch(options, function (newVal, oldVal) {
        this.$watch('options', function (newVal, oldVal) {
            let dropdown = this.$el
            if (newVal && newVal.length) {
                select.bindOneDropdown.bind(this)(dropdown, this.name === 'area')
            } else {
                console.log(`${this.name} mounting`)
            }
        })
    }

  }
}
</script>



// WEBPACK FOOTER //
// src/CustDropdown.vue